/**
 * Mouth-tape ATC contract shared by /pages/mouth-tape-e and the cart
 * month-supply control. IDs are copied from assets/sleep-karma-pdp.js
 * PRODUCT (the live /pages/mouth-tape-a buybox). Do not change variant
 * ids, selling-plan ids, or display amounts here without updating that
 * file — this test must charge the same Skio plans as A.
 *
 * Display amounts are button copy only. Shopify prices the line from
 * the variant id, quantity, and selling_plan.
 */
var SK_MOUTH_TAPE_ATC = {
  variants: {
    'full-1': { id: 46066516656369 },
    'full-3': { id: 46072098324721 },
    'full-6': { id: 46072098357489 },
    'slim-1': { id: 46066516721905 },
    'slim-3': { id: 46072098390257 },
    'slim-6': { id: 46072098423025 }
  },
  sellingPlans: {
    '1': { id: 5171773681 },
    '3': { id: 5171740913 },
    '6': { id: 5171806449 }
  },
  display: {
    sub: {
      '1': { total: '$34.97', orig: '$49.95' },
      '3': { total: '$82.41', orig: '$149.85' },
      '6': { total: '$149.88', orig: '$299.70' }
    },
    oneTime: {
      '1': { total: '$49.95' },
      '3': { total: '$149.85' },
      '6': { total: '$299.70' }
    }
  }
};

/**
 * Build the /cart/add.js item A submits.
 * state: { style: 'full'|'slim', pack: '1'|'3'|'6', isSubscription: boolean }
 * properties: optional line properties (E sets _sk_simplified_buybox).
 * One-time purchases omit selling_plan so the plan is cleared.
 */
function skMouthTapeAtcPayload(state, properties) {
  if (!state) return null;
  var pack = String(state.pack);
  var variant = SK_MOUTH_TAPE_ATC.variants[state.style + '-' + pack];
  var plan = SK_MOUTH_TAPE_ATC.sellingPlans[pack];
  if (!variant || !plan) return null;
  var payload = {
    id: variant.id,
    quantity: parseInt(pack, 10) || 1
  };
  if (properties) payload.properties = properties;
  if (state.isSubscription) payload.selling_plan = plan.id;
  return payload;
}
